<template>
  <el-tooltip :manual="!ismultiple" placement="top">
    <div slot="content">{{ tooltiptext }}</div>
    <el-select
      v-model="value"
      placeholder="请选择"
      class="do-select"
      size="mini"
      :multiple="ismultiple"
      collapse-tags
      @change="changeSelect"
      popper-class="app-select-self"
      ref="elSelect"
    >
      <div class="input-search">
        <el-input v-model="text" size="mini" suffix-icon="el-icon-search" />
      </div>

      <div v-if="haslabel == false">
        <div v-if="sortitem">
          <div @click="clickclear" class="clearbutton">
            <span style="font-size: 14px">清空</span>
          </div>

          <el-option
            v-for="item in sortitem"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </div>
      </div>

      <!-- --------------list item为对象----------------------- -->
      <div v-else>
        <el-option
          v-for="item in list.filter(
            (i) => !text || i.label.toLowerCase().includes(text.toLowerCase())
          )"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </div>
      <!-- --------------------------------------------------------- -->
    </el-select>
  </el-tooltip>
</template>

<script>
import { getArrDifference, arraydelete, isInArray } from "../utils/tool";
export default {
  data() {
    return {
      value: this.ismoren ? [] : this.defaultValue,
      text: "",
      isnone: false,
    };
  },
  props: {
    list: Array,
    // type: Number,
    // index: Number,
    defaultValue: String,
    obj: String,
    alllabel: { type: String, default: "全部" },
    isalllabel: { type: Boolean, default: true },
    ismultiple: { type: Boolean, default: true }, //false为单选
    haslabel: { type: Boolean, default: false }, //传进来的数组item不为对象无label
    ismoren: { type: Boolean, default: false },
    ishuizongver: { type: Boolean, default: false },
    ishuizongchnl: { type: Boolean, default: false },
  },
  // activated() {
  //   this.$refs.elSelect.$parent.value = [""];
  // },

  methods: {
    clickclear() {
      this.$refs.elSelect.$parent.$parent.value = [];
      // this.$refs.elSelect.$parentvalue = [];
      this.$refs.elSelect.selected = [];
      this.$emit("setSelectValue", {
        val: [],
        obj: this.obj,
        ismultiple: this.ismultiple,
      });
    },
    changeSelect(val) {
      // console.log(this.$refs.elSelect.$parent.value);
      // console.log(val)
      if (val.length < 5) {
        let hasall = false;
        if (val.length > 0 && this.ismultiple) {
          let arr = val.slice();
          val.forEach((i) => {
            if (i == "") {
              hasall = true;
            }
          });
          if (hasall) {
            let index = arr.indexOf("");
            arr.splice(index, 1);
            arr.unshift("");
            val = arr;
          }
        }
        if (val.length > 0) {
          this.$emit("setSelectValue", {
            val: val,
            // val: this.value,
            obj: this.obj,
            ismultiple: this.ismultiple,
          });
        } else {
          this.$emit("setSelectValue", {
            val: [],
            // val: this.value,
            obj: this.obj,
            ismultiple: this.ismultiple,
          });
        }
      }
    },
  },
  computed: {
    tooltiptext() {
      let text = "";
      if (this.ismultiple) {
        let arr = this.value.slice();
        if (arr.length == 0) {
          text = "无数据";
        }
        if (isInArray(arr, "")) {
          let index = arr.indexOf("");
          arr.splice(index, 1, `${this.alllabel}`);
          text = arr.join();
        } else {
          text = arr.join();
        }
      } else {
        text = this.value;
      }
      if (text == "") {
        text = "无选项";
      }
      return text;
    },
    isall() {
      return (
        this.isalllabel == true &&
        (!this.text ||
          this.alllabel.toLowerCase().includes(this.text.toLowerCase()))
      );
    },
    sortitem() {
      return this.list.filter((item) => {
        return (
          !this.text || item.toLowerCase().includes(this.text.toLowerCase())
        );
      });
    },
  },
  watch: {
    defaultValue: {
      handler(n, o) {
        if (n !== o) {
          this.value = this.ismoren ? [""] : n;
        }
      },
      deep: true, //对象内部属性的监听，关键。
    },
    value: {
      handler(n, o) {
        // console.log(o);
        if (this.ishuizongchnl || this.ishuizongver) {
          let difference = getArrDifference(n, o)[0];
          let isdifference = difference == ""; //true时点击的全部 false点击的非全部

          let oldhasalll = o.indexOf("") > -1; //true 原本被选中 false 原本没被选中
          if (difference !== undefined) {
            if (isdifference) {
              if (!oldhasalll) {
                this.value = [""]; //点全部 且原本全部不在被选中
                this.changeSelect(this.value);
              }
            } else {
              if (oldhasalll && n.length > 1) {
                this.value = arraydelete(n, ""); //点非全部 且原本全部在被选中
                this.changeSelect(this.value);
              }
            }
          }
        }
        if (n.length > 4) {
          this.$message("最多四个维度");
          this.value = o;
          this.changeSelect(o);
        }
      },
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" >
.app-select-self .el-scrollbar {
  display: block !important;
  position: relative;
}
.clearbutton {
  display: flex;
  // justify-content: center;
  padding: 0 20px;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;

  &:hover {
    background: #f5f7fa;
    cursor: pointer;
  }
}
.do-divider {
  position: sticky;
  top: 18px;
}
</style>
<style lang="less" scoped>
.do-select {
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
}
.input-search {
  width: 90%;
  margin-left: 5%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 30;
}
.divider-div {
  height: 36px;
  position: sticky;
  top: 23px;
  z-index: 29;
  margin-left: 5px;
}
.divider-line {
  display: inline-block;
  height: 28px;
  color: #3d90ff;
  font-size: 12px;
  font-weight: 500;
  line-height: 28px;
  padding: 0 12px;
  background: #e7e8fd;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  margin: 5px 0 5px 5px;
}
.divider-div::after {
  float: left;
  margin-top: -19px;
  content: "";
  width: 100%;
  height: 1px;
  border-top: 1px solid #e8e8e8;
  margin-left: 5px;
}
// .el-select-dropdown.is-multiple .none.selected:after {
//   content: "";
// }
// .el-select-dropdown.is-multiple .none.selected {
//   color: #606266;
// }
</style>